// useMediaMessageData.js - Data Layer Hook Genérico (Optimizado)
import { useState } from 'react';

/**
 * Hook de capa de datos genérico para mensajes multimedia (imagen, video, documento, sticker, etc).
 * Solo gestiona carga de URL, caption y loading/error.
 *
 * @param {Object} params
 * @param {Object} params.data - Objeto mensaje
 * @param {string|string[]} [params.urlField='contentMediaUrl'] - Campo de la URL en el mensaje.
 *   Con una lista, gana el primero que venga informado: así un audio puede ofrecer una copia
 *   reproducible en todos los navegadores y caer a la URL entregada cuando no exista.
 * @param {string} [params.captionField='contentMediaCaption'] - Campo del caption en el mensaje
 * @returns {Object}
 */
export default function useMediaData({ data, urlField = 'contentMediaUrl' }) {
  const fields = Array.isArray(urlField) ? urlField : [urlField];
  const resolvedUrl = fields.map((field) => data?.[field]).find(Boolean);

  const [url, setUrl] = useState(resolvedUrl);
  const [loading, setLoading] = useState(resolvedUrl ? true : false);
  const [error, setError] = useState(false);
  return { url, setUrl, loading, setLoading, error, setError };
}
